/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const AllowedOriginStatus = {
  Pending: "pending",
  Approved: "approved",
  Rejected: "rejected",
} as const;
export type AllowedOriginStatus = ClosedEnum<typeof AllowedOriginStatus>;

export type AllowedOrigin = {
  /**
   * The creation date of the allowed origin.
   */
  createdAt: Date;
  /**
   * The ID of the allowed origin
   */
  id: string;
  /**
   * The origin URL
   */
  origin: string;
  /**
   * The ID of the project
   */
  projectId: string;
  status: AllowedOriginStatus;
  /**
   * The last update date of the allowed origin.
   */
  updatedAt: Date;
};

/** @internal */
export const AllowedOriginStatus$inboundSchema: z.ZodMiniEnum<
  typeof AllowedOriginStatus
> = z.enum(AllowedOriginStatus);

/** @internal */
export const AllowedOrigin$inboundSchema: z.ZodMiniType<
  AllowedOrigin,
  unknown
> = z.pipe(
  z.object({
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    id: z.string(),
    origin: z.string(),
    project_id: z.string(),
    status: z._default(AllowedOriginStatus$inboundSchema, "pending"),
    updated_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "created_at": "createdAt",
      "project_id": "projectId",
      "updated_at": "updatedAt",
    });
  }),
);

export function allowedOriginFromJSON(
  jsonString: string,
): SafeParseResult<AllowedOrigin, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AllowedOrigin$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AllowedOrigin' from JSON`,
  );
}
